module.exports = __webpack_public_path__ + "img/zy_right2.f2de1796.png";